import { useEffect, useRef, useState } from 'react';
import { StethoscopeIcon, PillBottleIcon, CreditCardIcon, ShieldHeartIcon } from '../components/Icons';

// Tiny scroll-triggered card
function FeatureCard({ title, description, icon, delay = 0 }) {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.disconnect(); // Only animate once
      }
    });

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div 
      ref={ref}
      style={{ transitionDelay: `${delay}s` }}
      className={`flex flex-col items-center text-center bg-white p-6 rounded-xl shadow-md hover:shadow-xl hover:border-primary transition-all duration-700 ease-out border border-transparent
        ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}
      `}
    >
      <div className="mb-4 bg-secondary-light p-4 rounded-full flex items-center justify-center">
        {icon}
      </div>
      <h3 className="text-xl font-semibold text-primary mb-2">{title}</h3>
      <p className="text-sm text-neutral-dark">{description}</p>
    </div>
  );
}

function FeatureGrid() {
  const features = [
    {
      title: "Proven Tirzepatide",
      description: "Same active ingredient as Mounjaro and Zepbound, at a fraction of the cost. Trusted by thousands.",
      icon: <PillBottleIcon />
    },
    {
      title: "Comprehensive Support",
      description: "Doctor consultations, personalized dashboard, refill management — full support at every step.",
      icon: <StethoscopeIcon />
    },
    {
      title: "Affordable & Transparent",
      description: "No memberships. No hidden fees. Semaglutide plans from just $75/month. Pay only if approved.",
      icon: <CreditCardIcon />
    },
    {
      title: "Trusted Healthcare Network",
      description: "Serving over 90,000 patients nationwide since 2008. HIPAA-compliant, US-based care.",
      icon: <ShieldHeartIcon />
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
      {features.map((feature, index) => (
        <FeatureCard 
          key={index}
          title={feature.title}
          description={feature.description}
          icon={feature.icon}
          delay={(index * 0.2)+.5} // 0.1s stagger
        />
      ))}
    </div>
  );
}

export default FeatureGrid;
